import { render, staticRenderFns } from "./VxLazy.vue?vue&type=template&id=aa384a98&"
import script from "./VxLazy.vue?vue&type=script&lang=js&"
export * from "./VxLazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports